import { FC } from 'react';
import { Flex } from 'antd';
import { styled } from 'styled-components';
import { Select } from 'components/Base/Select';
import { SelectProps } from 'components/Base/Select/Select.types';
import { TClassItemUI } from 'data/types/workshops.types';
import { getTextFromI18n } from 'helpers/utils';

type Props = {
  classes?: TClassItemUI[];
  value?: string;
  onChange?: (value: string) => void;
};

const SRegisteredCount = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colorBlackDescription};
`;

// Language + age group on the left, current registrant count on the right so
// admins can tell the sessions apart at a glance.
const renderOption: SelectProps['optionRender'] = option => (
  <Flex justify="space-between" align="center" gap={12}>
    <span>{option.label}</span>
    <SRegisteredCount>
      {option.data.registrantsCount ?? 0} registered
    </SRegisteredCount>
  </Flex>
);

const SessionSelect: FC<Props> = ({ classes, value, onChange }) => {
  const options = (classes || []).map(cls => {
    const language = getTextFromI18n(
      `enums.language.${cls.language.value.value}`,
    );
    const ageGroup = getTextFromI18n(
      `enums.age-group.${cls.ageGroup.value.value}`,
    );
    return {
      value: cls.id,
      label: `${language} · ${getTextFromI18n(
        'descriptions.input-labels.AGES',
      )} ${ageGroup}`,
      registrantsCount: cls.registrantsCount,
    };
  });

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Select Session"
      style={{ width: '100%' }}
      optionRender={renderOption}
    />
  );
};

export default SessionSelect;
